import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** The name of the payment icon to display. Must match a supported icon name */
  iconName: PropTypes.string,
  /** Accessible label for the icon. If provided, used as `aria-label` for screen readers */
  labelText: PropTypes.string
};
var paymentIcons = {
  agmo: 'AGMO',
  'ali-pay': 'Alipay',
  alipay: 'Alipay',
  amex: 'Amex',
  '003': 'Amex',
  'anf-credit-card': 'ANF-Card',
  anf: 'ANF-Card',
  applepay: 'Apple-Pay',
  astropay: 'AstroPay',
  astropaycard: 'AstroPay',
  bancontact: 'Bancontact',
  bitcoin: 'Bitcoin',
  bleue: 'Carte-Bleue',
  '010': 'Carte-Bleue',
  boleto: 'Boleto',
  boletobancario: 'Boleto',
  cash: 'Cash',
  cb: 'CB',
  'cod-jp': 'COD-JP',
  'default-card': 'Credit-Card',
  '021': 'Credit-Card',
  debit: 'Credit-Card',
  discover: 'Discover',
  '004': 'Discover',
  ekonto: 'eKonto-ePlatby',
  elv: 'ELV',
  eps: 'eps',
  euteller: 'Euteller',
  ewire: 'ewire',
  giropay: 'giropay',
  'google-pay': 'Google-Pay',
  ideal: 'iDeal',
  instadebit: 'INSTADEBIT',
  jcb: 'JCB',
  '007': 'JCB',
  klarna: 'Klarna',
  'klarna-account': 'Klarna-Account',
  'klarnaaccount-NL': 'Klarna-Account',
  'klarna-box-ratenkauf': 'Klarna-Ratenkauf',
  'klarnaaccount-DE': 'Klarna-Ratenkauf',
  'klarna-box-rechnung': 'Klarna-Rechnung',
  'klarnainvoice-DE': 'Klarna-Rechnung',
  'klarna-factuur': 'Klarna-Factuur',
  'klarnainvoice-NL': 'Klarna-Factuur',
  'klarna-lasku': 'Klarna-Lasku',
  'klarnainvoice-FI': 'Klarna-Lasku',
  'klarna-rechnung': 'Klarna-Rechnung',
  'klarnainvoice-AT': 'Klarna-Rechnung',
  'klarna-tili': 'Klarna-Tili',
  'klarnaaccount-FI': 'Klarna-Tili',
  konbini: 'Konbini',
  mastercard: 'MasterCard',
  '002': 'MasterCard',
  mistercash: 'Bancontact',
  'moneta-ru': 'MonetaRu',
  paypal: 'PayPal',
  ppl: 'PayPal',
  payu: 'PayU',
  poli: 'POLi',
  polinz: 'POLi',
  przelewy24: 'Przelewy24',
  postepay: 'postepay',
  'qiwi-wallet': 'QIWI-Wallet',
  qiwi: 'QIWI-Wallet',
  'safety-pay': 'Safety-Pay',
  safetypay: 'Safety-Pay',
  sofort: 'Sofort',
  sofortuberweisung: 'Sofort',
  sporopay: 'SporoPay',
  swiff: 'swiff',
  trustpay: 'TrustPay',
  venmo: 'venmo',
  visa: 'Visa',
  '001': 'Visa',
  'visa-checkout': 'Visa-Checkout',
  VISA_CHECKOUT: 'Visa-Checkout',
  'visa-debit': 'Visa-Debit',
  '011': 'Visa-Debit',
  'visa-electron': 'Visa-Electron',
  '012': 'Visa-Electron',
  webmoney: 'WebMoney',
  wechat: 'WeChat',
  wechatpay: 'WeChat',
  yandex: 'Yandex',
  'Store-JP': 'Store-JP',
  'gift-card': 'Gift-Card',
  giftcard: 'Gift-Card'
};
function PaymentIcon(_ref) {
  var _ref$iconName = _ref.iconName,
    iconName = _ref$iconName === void 0 ? 'default-card' : _ref$iconName,
    labelText = _ref.labelText;
  var imageName = paymentIcons[iconName] || iconName;
  return imageName === 'Gift-Card' ? /*#__PURE__*/React__default.createElement("span", {
    "aria-label": labelText || '',
    className: "payment-icon",
    "data-icon-name": iconName,
    role: "img"
  }) : /*#__PURE__*/React__default.createElement("img", {
    src: "https://img.abercrombie.com/is/image/anf/payment_".concat(imageName, ".png"),
    alt: labelText || '',
    className: "payment-icon-new"
  });
}
PaymentIcon.propTypes = propTypes;

export { PaymentIcon as default };
//# sourceMappingURL=PaymentIcon.js.map
